module.exports = __webpack_public_path__ + "img/blender.587395c0.png";